<script setup>
defineProps({
  variant: {
    type: String,
    validators: value => ['primary', 'secondary', 'tertiary'].includes(value),
    default: 'primary',
  },
  size: {
    type: String,
    validators: value => ['sm', 'md', 'lg'].includes(value),
    default: 'md',
  },
  text: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  iconPack: {
    type: String,
    default: 'linear',
    validators: value => ['linear', 'twotones', 'flags'].includes(value),
  },
})
</script>

<template>
  <button
    v-bind="$attrs"
    class="hover:bg-neutral-10 flex w-full items-center gap-2 rounded-lg px-5 py-2 text-sm font-normal"
  >
    <ImoIcon v-if="icon" :size="14" :name="icon" :pack="iconPack" />
    <p v-if="text">{{ text }}</p>
  </button>
</template>

<style scoped>
@reference "@/assets/style/main.css";
</style>
